import { css } from '@emotion/react';
import React from 'react';

import { IRoomAvailabilityInstance } from '@/availability/models';
import { Box, Flex } from '@/box';
import { ImageSlider } from '@/core/components/controls/ImageSlider.component';
import Card from '@/core/components/layout/Card.component';
import { useTheme } from '@/ui/theme';

interface SearchResultRoomCardProps {
  children: React.ReactNode;
  'aria-labelledby'?: string;
  testId?: string;
  images: IRoomAvailabilityInstance['room']['images'];
}

export const SearchResultRoomCard = (props: SearchResultRoomCardProps) => {
  const {
    componentProperties: { bedroomCard, imageSlider },
  } = useTheme();

  return (
    <Card
      css={css({
        ...bedroomCard,
        span: {
          color: bedroomCard?.color,
        },
        h2: {
          span: {
            ...bedroomCard?.roomTitle,
            ['@media all and (max-width: 730px)']:
              bedroomCard?.roomTitle?.mobile,
          },
        },
        ['@media all and (max-width: 639px)']: {
          padding: '0 28px 28px',
          ...bedroomCard?.mobile,
        },
        '.Description': bedroomCard?.description,
      })}
      aria-labelledby={props['aria-labelledby']}
      testId={props.testId}
      // Unmask section in FullStory
      className="fs-unmask"
    >
      <Flex flexWrap="wrap">
        <Box width={[1, 368]} paddingInlineEnd={[0, 32]}>
          {props.images && (
            <div
              css={{
                '@media all and (max-width: 639px)': {
                  width: 'calc(100% + 56px)',
                  marginInlineStart: '-28px',
                  ...imageSlider?.mobile,
                },
              }}
            >
              <ImageSlider images={props.images} />
            </div>
          )}
        </Box>
        <Flex flex={1} minWidth={200}>
          {props.children}
        </Flex>
      </Flex>
    </Card>
  );
};
